import React from "react";
import Heading from "../../components/common/Typography/Heading";
import ContactUSForms from "./Forms/ContactUsForms";
import {
  publicMainHeaderOffsetClass,
  PUBLIC_HELP_CENTRE_BLOCK_GAP_CLASS,
} from "../Public/shared/publicLayoutSpec";

const ContactUsLayout = () => {
  return (
    <div
      className={`mx-auto w-full max-w-field-page-md min-h-screen ${publicMainHeaderOffsetClass()}`}
    >
      <Heading variant={"h1"} className="text-center w-full text-offblack">
        Contact Us
      </Heading>
      <div className={PUBLIC_HELP_CENTRE_BLOCK_GAP_CLASS}>
        <ContactUSForms />
      </div>
    </div>
  );
};

export default ContactUsLayout;
